__turbopack_context__.v({
  "badgeList": "BadgeList-module__kS-q8G__badgeList",
});
